import { render, staticRenderFns } from "./ModulesPage.vue?vue&type=template&id=4e1c2f3a"
import script from "./ModulesPage.vue?vue&type=script&lang=js"
export * from "./ModulesPage.vue?vue&type=script&lang=js"
import style0 from "./ModulesPage.vue?vue&type=style&index=0&id=4e1c2f3a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports